import { BankOperationStatusesNew } from 'constants/bankOperationStatusesNew';
import { Resources } from 'constants/resources';
import { Role } from 'constants/roles';

import CreateIcon from '@mui/icons-material/Create';
import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { useRouteTabs } from 'hooks/useRouteTabs';
import { BankOperationsEditCommentDialog } from 'pages/Finance/BankOperations/BankOperationsEditCommentDialog/BankOperationsEditCommentDialog';
import { useBankOperationsAvailableActions } from 'pages/Finance/BankOperations/hooks/useBankOperationsAvailableActions';
import { useShowController } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { ContextMenu, ContextMenuButton } from 'shared/mui/ContextMenu';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { BankOperation } from 'types/embedded/bankOperation';

import { BankOperationsShowCancelDialog } from './BankOperationsShowCancelDialog/BankOperationsShowCancelDialog';
import { BankOperationsShowChipFields } from './BankOperationsShowChipFields';
import { BankOperationsShowTabs } from './BankOperationsShowTabs/BankOperationsShowTabs';

export const BankOperationsShow: React.FC = () => {
  const { record } = useShowController<BankOperation>({
    resource: Resources.BankOperations,
  });
  const { data = [] } = useBankOperationsAvailableActions(record?.originId);
  const { isHaveRole } = usePermissions();
  const { currentTab, handleTabChange } = useRouteTabs();

  const {
    record: recordModalCancel,
    handleOpenRecordModal: handleOpenModalCancel,
    openRecordModal: openModalCancel,
    handleCloseRecordModal: handleCloseModalCancel,
  } = useRecordModal<BankOperation>();

  const {
    record: recordEditComment,
    handleOpenRecordModal: handleOpenRecordModalEditComment,
    openRecordModal: openRecordModalEditComment,
    handleCloseRecordModal: handleCloseRecordModalEditComment,
  } = useRecordModal<BankOperation>();

  const isEditCommentAvailable =
    isHaveRole([Role.FinanceLead, Role.Admin]) &&
    record?.status?.value !== BankOperationStatusesNew.Canceled;

  const renderActions = (): React.ReactElement[] | false => {
    const actions = [];

    if (data.includes(BankOperationStatusesNew.Canceled)) {
      actions.push(
        <Button
          color="error"
          key="btn-cancel"
          label="Аннулировать"
          onClick={() => handleOpenModalCancel(record)}
          variant="outlined"
        />,
      );
    }

    return actions.length ? actions : false;
  };

  return (
    <ShowPage
      actions={
        isEditCommentAvailable ? (
          <ContextMenu key="context-menu-button">
            <ContextMenuButton
              icon={<CreateIcon fontSize="small" />}
              label="Редактировать комментарий"
              onClick={() => handleOpenRecordModalEditComment(record)}
            />
          </ContextMenu>
        ) : undefined
      }
      listName="Банковские операции"
      resource={Resources.BankOperations}
      rightActionsSlot={renderActions()}
      title="Просмотр банковской операции"
    >
      <BankOperationsShowChipFields />
      <BankOperationsShowTabs handleTabChange={handleTabChange} initialTab={currentTab} />
      <BankOperationsShowCancelDialog
        onClose={handleCloseModalCancel}
        open={openModalCancel}
        record={recordModalCancel}
      />
      <BankOperationsEditCommentDialog
        onClose={handleCloseRecordModalEditComment}
        open={openRecordModalEditComment}
        record={recordEditComment}
      />
    </ShowPage>
  );
};
